import { Check } from 'lucide-react';

interface ChoiceButtonProps {
  label: string;
  selected: boolean;
  onSelect: () => void;
}

/** Keuzeknop voor de vier vaste redenen (H1). */
export function ChoiceButton({ label, selected, onSelect }: ChoiceButtonProps) {
  return (
    <button type="button" className="choice" aria-pressed={selected} onClick={onSelect}>
      {label}
      {selected ? <Check size={20} strokeWidth={2} aria-hidden /> : null}
    </button>
  );
}
